import { render } from "./a-tabs.vue?vue&type=template&id=08e753ae&scoped=true&ts=true"
import script from "./a-tabs.vue?vue&type=script&lang=ts"
export * from "./a-tabs.vue?vue&type=script&lang=ts"

import "./a-tabs.vue?vue&type=style&index=0&id=08e753ae&lang=sass&scoped=true"
import "./a-tabs.vue?vue&type=style&index=1&id=08e753ae&lang=css"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e753ae"]])

export default __exports__